import AsyncStorage from '@react-native-async-storage/async-storage';

export async function getTutorialState() {
  const tutorialState = await AsyncStorage.getItem('tutorial');
  try {
    const json = JSON.parse(tutorialState);
    if (json) {
      return json;
    }

    return { seen: false };
  } catch (err) {
    return null;
  }
}

export async function saveTutorialState() {
  try {
    await AsyncStorage.setItem('tutorial', JSON.stringify({ seen: true }));
  } catch (error) {
    // Error saving data
    console.log('Save tutorial state error', error);
  }
}
